import React, { useState, useEffect, useRef } from 'react'
import { DataTable, Column } from 'primereact/datatable'
import { Checkbox } from 'primereact/checkbox'
// import 'primereact/resources/themes/nova-light/theme.css'
import 'primereact/resources/themes/saga-orange/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import './styles.css'
import { Row, Col, Button } from 'reactstrap'
import axios from 'axios'
import { formatDateWithTimezone, timeWithoutTimeZone } from '../../utils/utcTime'
import {
  COLUMN_RESIZE_FIT,
  DEFAULT_FILTER_MATCH_MODE,
  DEFAULT_LAZY,
  DEFAULT_RESPONSIV,
  DEFAULT_SELECTION_MODE,
  DEFAULT_SORT_COLUMN,
  DEFAULT_SORT_MODE,
  EMPTY_MESSAGE,
  PAGE_SAZE_OPTIONS,
} from '../../constants/primeTableConstants'
import { notificationDanger } from '../../utils/customToastify'

export const DEFAULT_PAGE_SAZE = 5

const CustomPrimeTable = React.forwardRef(
  (
    {
      data,
      columns,
      selectionMode,
      showActions,
      onSelectionChange,
      lazy,
      query,
      onEdit,
      onDelete,
      onAdd,
      pageSizeOptions,
      onPage,
      onSort,
      onFilter,
      onOpenTab,
      newTab,
      stateKey,
      leftButtons,
      excelExport,
      selectRows,
      hideTotalRowCount,
      hideEdit,
      isLoaded,
      rightButtons,
      addDisabled,
      addHidden,
      findDisabled,
      findHidden,
      getSelectedRows,
      onRowClick,
      shownRelatedEntities,
      card,
      columnResizeMode,
      areClearedTableFilters,
      pageSize,
      tableClassName,
      headerColumnGroup,
      scrollable,
      frozenWidth,
      frozenHeaderColumnGroup,
      resizableColumns,
      cellSelection,
      onCellClick,
      defaultSortMeta,
      hidePaginator,
      header,
      rowGroupFooterTemplate,
      groupRowsBy,
      rowGroupMode,
      rowClassName,
      rowGroupHeaderTemplate,
      isRowSelectable,
      hideDelete,
      getHideEditForRow,
      getHideDeleteForRow,
      showSelectPage,
      rowExpansionTemplate,
      expandableRows,
    },
    ref
  ) => {
    const [tableState, setTableState] = useState({
      filter: false,
      multiSortMeta: [],
      filters: {},
      dataPageSize: DEFAULT_PAGE_SAZE,
      query: {},
    })
    const [selectedRows, setSelectedRows] = useState([])
    const [expandedRows, setExpandedRows] = useState(null)
    let time

    const isInitialMount = useRef(true)

    useEffect(() => {
      if (areClearedTableFilters === true) {
        const newTableState = {
          ...tableState,
          filters: {},
        }
        setTableState(newTableState)
      }
    }, [areClearedTableFilters])

    useEffect(() => {
      setSelectedRows([])
    }, [data, isLoaded])

    useEffect(() => {
      if (getSelectedRows) {
        getSelectedRows(selectedRows)
      }
    }, [selectedRows])

    const selectableRows =
      Array.isArray(data) && data.length
        ? isRowSelectable && typeof isRowSelectable === 'function'
          ? data.filter((row) => isRowSelectable(row))
          : data
        : []

    const areAllRowsSelected =
      selectableRows.length > 0 &&
      selectableRows.every((row) => selectedRows.some((selectedRow) => selectedRow.id === row.id))

    const isPartiallySelected =
      !areAllRowsSelected && selectableRows.some((row) => selectedRows.some((selectedRow) => selectedRow.id === row.id))

    const onSelectPageToggle = (event) => {
      event.originalEvent.stopPropagation()
      if (event.checked) {
        const selectedRowsById = new Set(selectedRows.map((row) => row.id))
        const mergedRows = [...selectedRows]

        selectableRows.forEach((row) => {
          if (!selectedRowsById.has(row.id)) {
            mergedRows.push(row)
          }
        })

        setSelectedRows(mergedRows)
      } else {
        const currentPageIds = new Set(selectableRows.map((row) => row.id))
        const remainingRows = selectedRows.filter((row) => !currentPageIds.has(row.id))
        setSelectedRows(remainingRows)
      }
    }

    useEffect(() => {
      if (tableState.multiSortMeta != defaultSortMeta && defaultSortMeta) {
        setTableState((prev) => ({
          ...prev,
          multiSortMeta: defaultSortMeta,
        }))
      }

      if (tableState.dataPageSize != pageSize && pageSize) {
        setTableState((prev) => ({
          ...prev,
          dataPageSize: pageSize,
        }))
      }

      if (tableState.query != query && query) {
        setTableState((prev) => ({
          ...prev,
          query: query,
        }))
      }
    }, [defaultSortMeta, pageSize, query])

    useEffect(() => {
      if (isInitialMount.current) {
        isInitialMount.current = false
      } else {
        if (time) {
          clearTimeout(time)
        }
        time = setTimeout(() => {
          onChangeSetFilters()
          time = null
        }, 500)
      }

      return function cleanup() {
        clearTimeout(time)
      }
    }, [tableState.filters])

    const actionTemplate = function (rowData) {
      const hideEditForThisRow = getHideEditForRow ? getHideEditForRow(rowData) : false
      const hideDeleteForThisRow = getHideDeleteForRow ? getHideDeleteForRow(rowData) : false
      return (
        <div className={'table-action'}>
          {!hideEdit && !hideEditForThisRow && (
            <Button className={'btn-gold table-button'} onClick={() => onEdit(rowData)}>
              <i className={`fas fa-edit`} title='Edit'></i>
            </Button>
          )}
          {!hideDelete && !hideDeleteForThisRow && (
            <Button
              className={'btn-gold table-button'}
              onClick={(e) => {
                e.stopPropagation()
                onDelete(rowData)
              }}
            >
              <i className={`fas fa-minus-circle`} title='Delete'></i>
            </Button>
          )}
          {newTab ? (
            <Button
              className={'btn-gold table-button'}
              onClick={() => (onOpenTab ? onOpenTab(rowData) : window.open(`${window.location.href}/${rowData.id}`))}
            >
              <i className={`fas fa-external-link-square-alt`} title='Open Tab'></i>
            </Button>
          ) : null}
        </div>
      )
    }

    if (showActions === true || showActions === undefined) {
      let actions = {
        _id: 'Actions',
        header: 'Actions',
        sortable: false,
        filter: false,
        body: actionTemplate,
        style: {
          width: newTab ? '100px' : '75px',
          padding: 0,
          'text-align': 'center',
        },
      }
      columns.findIndex((x) => x._id === 'Actions') === -1
        ? shownRelatedEntities
          ? columns.splice(columns.length - 1, 0, actions)
          : columns.push(actions)
        : columns.push()
    }

    const dynamicColumns = columns.map((col) => {
      let sortable = col.sortable
      let formatedBody = undefined
      if (sortable === undefined) {
        sortable = DEFAULT_SORT_COLUMN
      }

      if (col.format) {
        const format = typeof col.format === 'string' ? col.format : null
        formatedBody = (rowData) => {
          if (col.format === 'date') {
            return <div>{timeWithoutTimeZone(rowData[col.field])}</div>
          }
          return <div>{formatDateWithTimezone(rowData[col.field], format)}</div>
        }
      }

      let filterMatchMode = col.filterMatchMode
      if (filterMatchMode === undefined) {
        filterMatchMode = DEFAULT_FILTER_MATCH_MODE
      }

      let columnFilter = col.filter
      if (columnFilter === undefined) {
        columnFilter = tableState.filter
      }

      if (col.body === undefined) col.body = ''
      if (col.style === undefined) col.style = {}

      return (
        <Column
          key={col.field}
          field={col.field}
          className={col.className || ''}
          filter={columnFilter}
          filterElement={col.filterElement || null}
          filterMatchMode={filterMatchMode}
          header={col.header}
          body={formatedBody || col.body}
          sortable={sortable}
          style={col.style}
          frozen={col.frozen || false}
        />
      )
    })

    // eslint-disable-next-line no-unused-vars
    const getExcel = async () => {
      const { fileName, url } = excelExport
      axios({
        url: `/${url}/excel/`,
        method: 'POST',
        responseType: 'blob',
        data: excelExport,
      }).then((response) => {
        const DownloadUrl = window.URL.createObjectURL(
          new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
          })
        )
        const link = document.createElement('a')
        link.href = DownloadUrl
        link.setAttribute('download', `${fileName || url}.xlsx`)
        document.body.appendChild(link)
        link.click()
      })
    }

    const onChangeSetFilters = () => {
      const finalFilters = { filters: tableState.filters }
      Object.keys(tableState.filters).forEach((key) => {
        if (Object.keys(tableState.filters).length === 0) {
          finalFilters.filters[key] = ''
        }
        if (tableState.filters && !Object.keys(tableState.filters).includes(key)) {
          finalFilters.filters[key] = ''
        }
      })

      if (onFilter !== undefined) {
        onFilter({ filters: tableState.filters })
      }
    }

    const onFilterChange = (event) => {
      // console.log('ovde sam', event)
      setTableState({
        ...tableState,
        filters: event.filters,
      })
    }

    const onSortChange = async (event) => {
      setTableState({ ...tableState, multiSortMeta: event.multiSortMeta })
      onSort(event)
    }

    const onPageChange = async (event) => {
      setTableState({ ...tableState, dataPageSize: event.rows })
      onPage(event)
    }

    const totalRowCount = () => {
      const { first, limit, totalRecords } = tableState.query
      return Object.keys(tableState.query).length && !hideTotalRowCount ? (
        <div className='paginationRowCount'>{`${first + 1} to ${first + limit} of ${totalRecords}`}</div>
      ) : null
    }

    const selectedRowHandle = (event) => {
      if (onRowClick) {
        return
      }

      event.originalEvent.stopPropagation()
      if (event.type === 'checkbox') {
        if (isRowSelectable && typeof isRowSelectable === 'function') {
          const isSelectable = isRowSelectable(event.data)
          if (isSelectable) {
            setSelectedRows([...selectedRows, event.data])
          } else {
            notificationDanger('Unable to select')
          }
          return
        } else {
          setSelectedRows([...selectedRows, event.data])
          return
        }
      }
      if (onSelectionChange) {
        onSelectionChange({ value: { id: event.data.id }, data: event.data })
      }
    }

    const unselectedRowHandle = (event) => {
      if (event?.type === 'checkbox') {
        const newRow = selectedRows.filter((i) => i.id !== event.data.id)
        setSelectedRows(newRow)
      }
    }

    const onColumnResizeHandler = () => {
      if (card) {
        const cardElement = document.querySelector(`.${card}`)
        const dataTableElement = document.querySelector('.data-table-custom-class')
        const cardCoordinates = cardElement.getBoundingClientRect()
        const dataTableCoordinates = dataTableElement.getBoundingClientRect()

        // console.log("CARD", cardCoordinates.width);
        // console.log("TABLE", dataTableCoordinates.width);

        if (cardCoordinates.width < dataTableCoordinates.width) {
          dataTableElement.style.overflowX = 'hidden'
        } else {
          dataTableElement.style.minWidth = cardCoordinates.width - 10 + 'px'
          dataTableElement.childNodes[0].childNodes[0].style.minWidth = cardCoordinates.width - 15 + 'px'
        }
      }
    }

    return (
      <>
        <Row>
          <Col xs={12} className='p-1'>
            {!findHidden && (
              <Button
                onClick={() => setTableState({ ...tableState, filter: !tableState.filter })}
                disabled={findDisabled}
                size='sm'
                className='btn btn-gold'
              >
                Find
              </Button>
            )}
            {leftButtons && leftButtons()}
            <div className='float-right'>
              {/* {console.log(rightButtons)} */}
              {rightButtons && rightButtons(selectedRows)}
              {/* {excelExport && (
                <Button onClick={getExcel} size='sm' className='btn btn-gold mr-2'>
                  Export To Excel
                </Button>
              )} */}

              {!addHidden && (
                <Button onClick={onAdd} size='sm' disabled={addDisabled} className='btn btn-gold'>
                  Add
                </Button>
              )}
            </div>
          </Col>
        </Row>
        <Row>
          {/* ref={(el) => dt = el} */}
          <DataTable
            header={header}
            cellSelection={cellSelection}
            onCellClick={onCellClick}
            ref={ref}
            dataKey='id'
            className={`data-table-custom-class p-datatable-gridlines ${tableClassName || ''}`}
            value={data}
            paginator={hidePaginator ? false : true}
            selection={selectedRows}
            alwaysShowPaginator={true}
            paginatorLeft={totalRowCount()}
            lazy={lazy === undefined ? DEFAULT_LAZY : lazy}
            onPage={onPageChange}
            totalRecords={tableState.query?.totalRecords || 0}
            first={tableState.query?.first || 0}
            onFilter={onFilterChange}
            filters={tableState.filters}
            onSort={onSortChange}
            multiSortMeta={tableState.multiSortMeta}
            onRowSelect={selectedRowHandle}
            onRowUnselect={unselectedRowHandle}
            rows={query?.limit || DEFAULT_PAGE_SAZE}
            rowsPerPageOptions={pageSizeOptions || PAGE_SAZE_OPTIONS}
            sortMode={DEFAULT_SORT_MODE}
            responsive={DEFAULT_RESPONSIV}
            resizableColumns={resizableColumns !== undefined ? resizableColumns : true}
            onRowClick={onRowClick}
            reorderableColumns={true}
            columnResizeMode={columnResizeMode || COLUMN_RESIZE_FIT}
            selectionMode={selectionMode || DEFAULT_SELECTION_MODE}
            emptyMessage={EMPTY_MESSAGE}
            stateKey={stateKey}
            onColumnResizeEnd={onColumnResizeHandler}
            style={{ fintSize: '10px', width: '5000px' }}
            headerColumnGroup={headerColumnGroup || null}
            frozenHeaderColumnGroup={frozenHeaderColumnGroup || null}
            scrollable={scrollable}
            // scrollHeight='600px'
            frozenWidth={frozenWidth}
            rowGroupFooterTemplate={rowGroupFooterTemplate}
            groupRowsBy={groupRowsBy}
            rowGroupMode={rowGroupMode}
            rowGroupHeaderTemplate={rowGroupHeaderTemplate}
            rowClassName={rowClassName}
            expandedRows={expandedRows}
            onRowToggle={(e) => setExpandedRows(e.data)}
            rowExpansionTemplate={rowExpansionTemplate}
          >
            {expandableRows && <Column expander style={{ width: '3rem' }} />}
            {selectRows && (
              <Column
                selectionMode='multiple'
                header={
                  showSelectPage ? (
                    <div className='select-all-wrapper'>
                      <Checkbox
                        binary
                        checked={areAllRowsSelected}
                        indeterminate={isPartiallySelected}
                        onChange={onSelectPageToggle}
                      />
                    </div>
                  ) : null
                }
                className='customTableHeader'
              />
            )}
            {dynamicColumns}
          </DataTable>
        </Row>
      </>
    )
  }
)

export default CustomPrimeTable
